import {useRef, useState} from "react";
import {unstable_useBlocker as useBlocker, useNavigate} from "react-router-dom";
import {useUploadedImages} from "./useUploadedImages";

export const useConfirmNavigation = () => {
    const navigate = useNavigate();
    const {handleClearUploadedImages} = useUploadedImages();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [nextLocation, setNextLocation] = useState<string | null>(null);
    const [isBlocking, setIsBlocking] = useState(false);
    const [isDirty, setIsDirty] = useState(false);

    const hasBlocked = useRef(false);

    useBlocker(({nextLocation}) => {
        const isRealNavigation = nextLocation.pathname !== window.location.pathname;
        if (isRealNavigation && isDirty && !hasBlocked.current) {
            setNextLocation(nextLocation.pathname);
            setIsModalOpen(true);
            setIsBlocking(true);
            hasBlocked.current = true;
            return true;
        }
        return false;
    });

    const confirmNavigation = () => {
        setIsModalOpen(false);
        setIsBlocking(false);
        if (nextLocation) {
            handleClearUploadedImages();
            setIsDirty(false)
            setTimeout(() => navigate(nextLocation), 0);
        }
    };

    const cancelNavigation = () => {
        setIsModalOpen(false);
        setNextLocation(null);
        setIsBlocking(false);
        hasBlocked.current = false;
    };

    return {isModalOpen, confirmNavigation, cancelNavigation, isBlocking, setIsDirty, setIsModalOpen};
};
